export default {
    en: {
        errNetwork: 'English version of Notification<br>Нет подключения к серверу',
        incorrectResp: 'English version of Notification<br>Ошибка. Сервер вернул некорректный ответ',
        text5_1: 'English version of Notification<br>Ошибка. Ответ сервера: ',
        text5_2: '<br>Подробности в консоли',
            welcome: 'English version of Notification<br>Добро пожаловать!<br>Вам открыт доступ к приложению',
            hiAgain: 'English version of Notification<br>У вас есть доступ к приложению',
            bye: 'English version of Notification<br>Вы вышли из приложения',
        text1: 'English version of Notification<br>Доступ закрыт<br>Проверьте логин и пароль',
        someError: 'English version of Notification<br>Ошибка. Подробности в консоли',
        incorrectToken: 'English version of Notification<br>Alarm! Передан некорректный токен.<br>Доступ закрыт',
        emptyToken: 'English version of Notification<br>Alarm! Передан пустой токен.<br>Доступ закрыт',
        loginPlease: 'English version of Notification<br>Залогиньтесь',
        accTokenUpdated: 'English version of Notification<br>Access Token обновлен<br>У вас есть доступ к приложению',
        fakeToken: 'Ошибка безопастности<br>Похоже на подделку токена доступа<br>Залогиньтесь или обратитесь в поддержку',
    },
    uk: {
        errNetwork: 'Нет подключения к серверу',
        incorrectResp: 'Ошибка. Сервер вернул некорректный ответ',
        text5_1: 'Ошибка. Ответ сервера: ',
        text5_2: '<br>Подробности в консоли',
            welcome: 'Добро пожаловать!<br>Вам открыт доступ к приложению',
            hiAgain: 'У вас есть доступ к приложению',
            bye: 'Вы вышли из приложения',
        text1: 'Доступ закрыт<br>Проверьте логин и пароль',
        someError: 'Ошибка. Подробности в консоли',
        incorrectToken: 'Alarm! Передан некорректный токен.<br>Доступ закрыт',
        emptyToken: 'Alarm! Передан пустой токен.<br>Доступ закрыт',
        loginPlease: 'Залогиньтесь',
        accTokenUpdated: 'Access Token обновлен<br>У вас есть доступ к приложению',
        fakeToken: 'Ошибка безопастности<br>Похоже на подделку токена доступа<br>Залогиньтесь или обратитесь в поддержку',
    },
}